import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新内容
            </h2>
            <p className="mt-3 text-foreground-500">
              第一时间了解平台最新动态与精彩内容
            </p>
          </div>
          <Link
            to="/category/latest-news"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/latest-news"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}